import { z } from 'zod';

import type { TrainingClusterSpec } from './trainingClusterSpec';

/** 训练集群插件规格使用可版本化的扁平表单快照。 */
export const TcPluginSpecSchema = z.custom<Record<string, unknown>>((value) => value != null && typeof value === 'object');

/** 训练集群插件规格。 */
export type TcPluginSpec = Record<string, unknown>;

/** 训练集群插件 API 请求体。 */
export type TcApiPayload = TrainingClusterSpec & Record<string, unknown>;
